import { Link } from "react-router-dom";
import { useAppState } from "../context/AppState";

export default function AppHeader({ compact = false }) {
  const { address, locating, openAddress } = useAppState();

  return (
    <header className={`app-header ${compact ? "app-header--compact" : ""}`}>
      <Link to="/inicio" className="app-header__logo" aria-label="Ir a la portada">
        <img src="/assets/img/logos/logo.png" alt="Delivery Huaraz" />
      </Link>
      <button className="app-header__address" type="button" onClick={openAddress}>
        <span>{locating ? "Buscando ubicación…" : address?.address || "Selecciona tu dirección"}</span>
        <b aria-hidden="true">⌄</b>
      </button>
    </header>
  );
}
